
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/politicanodiscriminacion",
      function () {
        return require("private-next-pages/politicanodiscriminacion/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/politicanodiscriminacion"])
      });
    }
  